import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const RSMobileMenu = ({
  setMenuOpen,
  menuOpen,
  parentMenu,
  secondParentMenu,
  headerFullWidth,
}) => {
  const [home, setHome] = useState(false);
  const [about, setAbout] = useState(false);
  const [services, setServices] = useState(false);
  const [courses, setCourses] = useState(false);
  const [faqs, setFaqs] = useState(false);
  const [contact, setContact] = useState(false);

  return (
    <div
      className={
        headerFullWidth ? "container-fluid relative" : "container relative"
      }
    >
      <div className={menuOpen ? "mobile-menu-part open" : "mobile-menu-part"}>
        <div className="mobile-menu">
          <ul className="nav-menu">
            <li
              className={
                home
                  ? "menu-item-has-children current-menu-item"
                  : "menu-item-has-children"
              }
            >
              <Link
                to="/"
                className={parentMenu === "home" ? "active-menu" : ""}
              >
                Home
              </Link>
            </li>
            <li
              className={
                about
                  ? "menu-item-has-children current-menu-item"
                  : "menu-item-has-children"
              }
            >
              <Link
                to="/about-us"
                className={parentMenu === "about" ? "active-menu" : ""}
              >
                About Us
              </Link>
            </li>
            <li
              className={
                courses
                  ? "menu-item-has-children current-menu-item"
                  : "menu-item-has-children"
              }
            >
              <Link
                to="/services"
                className={parentMenu === "services" ? "active-menu" : ""}
                onClick={() => setCourses(!courses)}
              >
                Services
              </Link>
              <ul className={courses ? "sub-menu current-menu" : "sub-menu"}>
                <li>
                  <Link to="/consultation/mobile-app-development">Mobile App Development</Link>
                </li>
                <li>
                  <Link to="/consultation/web-application-development">Web Application Development</Link>
                </li>
                <li>
                  <Link to="/consultation/ai-machine-learning">AI & Machine Learning</Link>
                </li>
                <li>
                  <Link to="/consultation/cyber-security-vapt">Cyber Security & VAPT</Link>
                </li>
                <li>
                  <Link to="/consultation/devsecops-platform-engineering">DevSecOps & Platform Engineering</Link>
                </li>
                <li>
                  <Link to="/consultation/cto-as-a-service">CTO-as-a-Service</Link>
                </li>
                <li>
                  <Link to="/consultation/system-architecture-solution-design">System Architecture & Solution Design</Link>
                </li>
                <li>
                  <Link to="/consultation/product-discovery-mvp-development">Product Discovery & MVP Development</Link>
                </li>
                <li>
                  <Link to="/consultation/digital-transformation">Digital Transformation</Link>
                </li>
                <li>
                  <Link to="/consultation/performance-optimization-scalability">Performance Optimization & Scalability Engineering</Link>
                </li>
                <li>
                  <Link to="/consultation/quality-assurance-testing">Quality Assurance & Testing</Link>
                </li>
                <li>
                  <Link to="/consultation/ongoing-support-engineering-partnership">Ongoing Support & Engineering Partnership</Link>
                </li>
              </ul>
            </li>
            <li
              className={
                faqs
                  ? "menu-item-has-children current-menu-item"
                  : "menu-item-has-children"
              }
            >
              <Link
                to="/faq"
                className={parentMenu === "faqs" ? "active-menu" : ""}
              >
                FAQs
              </Link>
            </li>
            <li
              className={
                parentMenu === "community"
                  ? "menu-item-has-children current-menu-item"
                  : "menu-item-has-children"
              }
            >
              <Link
                to="/community"
                className={parentMenu === "community" ? "active-menu" : ""}
              >
                Community
              </Link>
            </li>
            <li
              className={
                contact
                  ? "menu-item-has-children current-menu-item"
                  : "menu-item-has-children"
              }
            >
              <Link
                to="/contact-us"
                className={parentMenu === "contact" ? "active-menu" : ""}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RSMobileMenu;
